<template>
    <v-autocomplete
        prepend-icon="label"
        :items="items"
        :item-text="'nombre'"
        :item-value="'id'"
        v-model="item"
        :label="$t('producto.labels.marca')"
        :loading="loading"
        :error="hasInputErrors('marca')"
        :error-messages="getInputErrors('marca')"
        color="secondary"
        item-color="secondary"
        :rules="isRequired ? required : []"
        :multiple="multiple"
        :chips="chips"
        :solo="solo"
        :disabled="disabled"
        :readonly="readonly"
        clearable
        :hide-details="hideDetails"
        :style="{ width: width, maxWidth: width }"
        :return-object="effectiveReturnObject"
    ></v-autocomplete>
</template>

<script>

    import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'
    
    
    import MarcaProvider from "../../../../marca/providers/MarcaProvider"

    export default {
        name: "MarcaCombobox",
        mixins: [InputErrorsByProps, RequiredRule],
        props:{
            // Puede recibir el id (String) o el objeto completo (Object) de la marca
            value: { type: [String, Array, Object] },
            multiple: { type: Boolean, default: false },
            solo: { type: Boolean, default: false },
            chips: { type: Boolean, default: false },
            readonly: { type: Boolean, default: false },
            disabled: { type: Boolean, default: false },
            isRequired: { type: Boolean, default: false },
            hideDetails: { type: Boolean, default: false },
            returnObject: { type: Boolean, default: false },
            itemValue: { type: String, default: "id" },
            width: { type: String, default: null },
        },
        data() {
            return {
                items: [],
                loading: false,
            }
        },
        computed: {
            effectiveReturnObject() {
                if (this.returnObject) return true;
                return this.value != null && typeof this.value === 'object' && !Array.isArray(this.value);
            },
           item: {
                get() { return this.value },
                set(val) {
                    if (val === null || val === undefined || val === '') {
                        this.$emit('input', null);
                        return;
                    }
                    if (typeof val === 'object') {
                        this.$emit('input', val);
                        return;
                    }
                    const foundItems = this.items.filter(item => String(item.id) === String(val));
                    if (foundItems.length > 0) {
                        this.$emit('input', foundItems[0]);
                    }
                }
            }
        },
        mounted() {
            this.fetch()
        },
        methods: {
            validate(){
              return this.$refs.form.validate()
            },
            fetch(){
               this.loading= true;
                MarcaProvider.fetchMarcas().then(r => {
                    this.items = r.data.marcaFetch
                }).catch(err => console.error(err))
                .finally(()=> this.loading = false)
            }
            
        }
    }
</script>

<style scoped>

</style>

